// extracted by mini-css-extract-plugin
export default {"container":"zs-z","heading":"As-z","text":"Bs-z","info":"Cs-z","link":"Ds-z","fullMaxWidth":"Es-z"};